import React from 'react';
import { motion } from 'framer-motion';
export function CoffeeProblemSection() {
  return <section className="w-full bg-charcoal py-20 md:py-28" data-id="element-12">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-13">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-14">
          {/* Left: Copy */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="space-y-6" data-id="element-15">
            <h2 className="font-headline text-4xl md:text-5xl text-white" data-id="element-16">
              Coffee gives. <br data-id="element-17" />
              <span className="text-lime" data-id="element-18">Then it takes.</span>
            </h2>

            <p className="text-lg text-gray-300 leading-relaxed" data-id="element-19">
              The first cup feels productive. Then the crash hits, the anxiety
              creeps in, and the second coffee becomes damage control.
            </p>

            <p className="text-lg text-gray-300 leading-relaxed" data-id="element-20">
              Zesty keeps the part you wanted from coffee — the lift, the focus,
              the ritual — without making your afternoon feel cooked.
            </p>

            <div className="pt-4" data-id="element-21">
              <a href="https://forms.gle/TCr9CceLKLVH7UWr6" target="_blank" rel="noopener noreferrer" className="inline-block px-8 py-4 bg-pink text-white font-semibold rounded-full hover:opacity-90 transition-opacity" data-id="element-22">
                JOIN WAITLIST →
              </a>
            </div>
          </motion.div>

          {/* Right: Comparison card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-neutral-800 rounded-[2rem] p-10 shadow-lg" data-id="element-23">
            <div className="grid grid-cols-2 gap-8" data-id="element-24">
              <div data-id="element-25">
                <h3 className="font-bold text-xs uppercase tracking-wider text-gray-400 mb-6" data-id="element-26">
                  THE USUAL ROUTINE
                </h3>
                <ul className="space-y-4 text-gray-300" data-id="element-27">
                  <li className="flex items-center" data-id="element-28">
                    <span className="w-1.5 h-1.5 rounded-full bg-gray-500 mr-3 flex-shrink-0" data-id="element-29"></span>
                    Spike
                  </li>
                  <li className="flex items-center" data-id="element-30">
                    <span className="w-1.5 h-1.5 rounded-full bg-gray-500 mr-3 flex-shrink-0" data-id="element-31"></span>
                    Jitters
                  </li>
                  <li className="flex items-center" data-id="element-32">
                    <span className="w-1.5 h-1.5 rounded-full bg-gray-500 mr-3 flex-shrink-0" data-id="element-33"></span>
                    Crash
                  </li>
                  <li className="flex items-center" data-id="element-34">
                    <span className="w-1.5 h-1.5 rounded-full bg-gray-500 mr-3 flex-shrink-0" data-id="element-35"></span>
                    Second coffee
                  </li>
                </ul>
              </div>

              <div data-id="element-36">
                <h3 className="font-bold text-xs uppercase tracking-wider text-lime mb-6" data-id="element-37">
                  THE ZESTY RITUAL
                </h3>
                <ul className="space-y-4 text-lime" data-id="element-38">
                  <li className="flex items-center" data-id="element-39">
                    <span className="w-1.5 h-1.5 rounded-full bg-lime mr-3 flex-shrink-0" data-id="element-40"></span>
                    Hydration-first
                  </li>
                  <li className="flex items-center" data-id="element-41">
                    <span className="w-1.5 h-1.5 rounded-full bg-lime mr-3 flex-shrink-0" data-id="element-42"></span>
                    Smooth focus
                  </li>
                  <li className="flex items-center" data-id="element-43">
                    <span className="w-1.5 h-1.5 rounded-full bg-lime mr-3 flex-shrink-0" data-id="element-44"></span>
                    Clean energy
                  </li>
                  <li className="flex items-center" data-id="element-45">
                    <span className="w-1.5 h-1.5 rounded-full bg-lime mr-3 flex-shrink-0" data-id="element-46"></span>
                    Daily use
                  </li>
                </ul>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}